require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./is.json") })
        }
      }, "path---is");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---is!./.cache/json/is.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---is!./.cache/json/is.json
// module chunks = 231608221292675